<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></h1>
<p class="P_Normal">I want to thank Hannah Irene and Jessie Potts. Hannah’s been a student of Russian ballet almost since I’ve known her, indeed, almost since she could walk. I’ve learned a lot about the discipline just by being her mom. I learn more every day she perseveres, and her help in getting the dance student’s perspective was invaluable.</p>
<p class="P_Normal">Jessie’s teaching experience gave me a totally different perspective on things in the dance studio, and I thank her for taking the time to read over the manuscript to make sure I got it right.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?403f8b22